/**
 * BASE_CHART_SCHEMA: common chart template containing core properties shared across charts.
 */
export const BASE_CHART_CONFIG = {
	chart: {
		spacing: 0,
		marginTop: 5,
		marginBottom: null,
		backgroundColor: null,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif',
			color: null
		},
		type: null,
		height: null,
		width: null
	},
	credits: {
		enabled: false
	},
	exporting: {
		chartOptions: {
			chart: {
				backgroundColor: '#fff'
			}
		}
	},
	legend: {
		reversed: false,
		enabled: false
	},
	navigation: {
		buttonOptions: {
			enabled: false
		}
	},
	navigator: {
		enabled: false
	},
	plotOptions: {
		line: {
			marker: {
				enabled: false
			}
		},
		bubble: {
			maxSize: 25
		},
		series: { stacking: null },
		bar: {
			pointWidth: null,
			groupPadding: null,
			pointPadding: null
		},
		column: {
			pointWidth: null
		}
	},
	scrollbar: {
		enabled: false
	},
	title: {
		text: null
	},
	tooltip: {
		backgroundColor: '#f9f9f9',
		borderColor: '#000',
		borderRadius: 0,
		padding: 15,
		shadow: false,
		useHTML: true,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif'
		},
		formatter: null
	},
	xAxis: null,
	yAxis: null,
	series: null,
	colors: null,
	subtitle: null,
	extensibleData: null
};
